import { Container, ContainerGutter, styled} from '@volkswagen-onehub/components-core';
import React, { useContext, useEffect } from 'react';
import { VehicleCategory } from '../../../types/enums/vehicles';
import Calculator from './Calculator';
import YourLocalDealer from './YourLocalDealer';
import TotalPrice from './TotalPrice';
import { useFinanceProvider } from '../../../utils/use-finance-provider';
import LeadOffer from '../../LeadOffer';
import {  Province, VehicleInterface } from '@vw-marketing/vw-ca-types';
import { DealerData, VehicleData } from '../../../types';
import { VehicleDetailsContext } from '../../../utils/details-context';

const PricingContainer = styled.div`
    @media screen and (min-width: 1040px) {
        grid-row: 2 / span 4;
        grid-column: 2 / 3;
    }
`;

export default () => {
  const context = useContext(VehicleDetailsContext);
  const vehicle = context.vehicle as VehicleData;
  const dealer = context.dealer as DealerData;
  const subscribe = useFinanceProvider(vehicle as VehicleInterface, dealer?.province as Province);

  useEffect(() => {
    return () => {
      subscribe?.unsubscribe();
    }
  }, [subscribe]);

    return (
        <PricingContainer>
            <Container
                stretchContent
                wrap="always"
                gutter={ContainerGutter.static350}>
                <LeadOffer vehicle={vehicle} />

                {vehicle?.category === VehicleCategory.NEW ? <TotalPrice vehicle={vehicle} /> : null}
                {vehicle?.category === VehicleCategory.CERTIFIED ? <Calculator /> : null}

                <YourLocalDealer />
            </Container>
        </PricingContainer>
    );
}
